import React, { PropTypes } from 'react';
import { get } from 'lodash';
import ModalConfirmationSettings from '../../modals/ModalConfirmationSettings';
import Store from '../../../store/Store';

const PagesRetailProducts = (props) => {
    const { routes, router, route, location } = props;
    const pathname = get(location, 'pathname')
    const components = get(routes, [routes.length - 1, 'components']);
    const { labels, itemToShow } = components;
    return (
        <div>
            {labels ? (
                <ModalLabelSettings
                    store={Store}
                    router={router}
                    route={route}
                    location={pathname}
                    component={itemToShow}
                />
            ) : (
                <ModalConfirmationSettings
                    store={Store}
                    router={router}
                    route={route}
                    location={pathname}
                    component={itemToShow}
                />
            )}
        </div>
    );
}

PagesRetailProducts.propTypes = {
    location: PropTypes.object,
    route: PropTypes.object,
    router: PropTypes.object,
    routes: PropTypes.array
};

PagesRetailProducts.contextTypes = {
    store: PropTypes.object
};

export default PagesRetailProducts;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesRetailProducts.js